import { useCallback, useEffect, useState } from 'react';

export const useAwaitedList = (
  eventKey: string,
  callBack: (eventKey: string, data: any) => void,
  timeout?: number,
) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    let timer: string | number | NodeJS.Timeout | undefined;
    if (data.length) {
      timer = setTimeout(() => {
        callBack(eventKey, data);
        setData([]);
      }, timeout || 1000);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [data, eventKey]);

  // @ts-expect-error idk
  const setItem = useCallback((value) => setData((prevState) => [...prevState, value]), []);

  return [setItem] as const;
};
